import gql from 'graphql-tag';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class CuentaBancariaService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerCuentaEmpresa(empresa_rut, banco_codigo, activo, callback) {
        const inputParams = {
            entidad: {
                empresa_rut,
                banco_codigo,
                activo,
            }
        };
        this.gqlclient.query({
            query: gql `
        query ($entidad: cuenta_bancariaInputType) {
          cuenta_bancaria {
            obtenerCuentaEmpresa(entidad: $entidad) {
              respuesta {
                registros {
                  empresa_rut
                  tipo_cuenta_bancaria_codigo
                  banco_codigo
                  numero_cuenta
                  observaciones
                  activo
                }
              }
            }
          }
        }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.cuenta_bancaria.obtenerCuentaEmpresa;
            callback({ mensajes, respuesta });
        });
    }
}
CuentaBancariaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CuentaBancariaService_Factory() { return new CuentaBancariaService(i0.ɵɵinject(i1.GraphQLClient)); }, token: CuentaBancariaService, providedIn: "root" });
